import React, { Component } from 'react';
import Select from 'react-select';
import { Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import ReactDataGrid from 'react-data-grid';
import axios from 'axios';
import { ROOT_URL } from '../../actions/root_url';
import moment from 'moment';
import { SkyLightStateless } from 'react-skylight';
import GenericDatePicker from '../Common/GenericDatePicker';

const { Selectors } = Data;

export class BOLListModal extends Component {
    constructor() {
        super();
        this.state = {
            rows: [],
            selectedRows: [],
            editedRows: [],
            filters: {},
            sortColumn: null,
            sortDirection: null,

            details: {
                rows: [],
                selectedRows: null,
                editedRows: [],
                filters: {},
            },

            editShipDateVisible: false,
            ship_date: null,
        };
        this.setShipDate = this.setShipDate.bind(this);
    }

    componentDidMount() {
        // this.props.fetchFJAgents(this.props.fjCustomerId).then((response) => {
        //     if (response.data) {
        //         this.initializeModal(response.data);
        //     }
        // }, (err) => {
        //     if (err.status === 500 || err.status === 404) {
        //         alert("Server error, please refresh page. If problem persists, contact administrator.");
        //     }
        // });
        let url = ``;
        // if (this.props.salesOrderNum) {
        //     url = `${ROOT_URL}v2/sales/bol/?sales_order__SONum=${this.props.salesOrderNum}`;
        // } else {
            url = `${ROOT_URL}v2/sales/bol/`;
        // }
        axios({
            method: 'GET',
            url: url,
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        })
            .then(res => {
                this.setState({
                    rows: res.data,
                    selectedRows: [],
                    editedRows: [],
                });
            }, err => {
            })
    }

    componentWillReceiveProps(nextProps) {
    }

    // initializeModal = (array) => {
    //     let index = 0;
    //     let formatter = [];
    //     if (array && array.length > 0) {
    //         array.map(r => {
    //             formatter.push({ Idx: index++, customer: r.customer, id: r.id, name: r.name, note: r.note, ref_num: r.ref_num });
    //         })
    //     } else {
    //         formatter.push({ Idx: 0, name: "", note: "" });
    //     }
    //     this.setState({
    //         rows: formatter,
    //         selectedRows: [],
    //         editedRows: [],
    //     });
    // }

    setShipDate(e) {
        // if (!this.props.Vendor) {
        //   alert('Please select a Vendor!');
        //   return;
        // }
        // if (e > this.state.toDate) {
        //   return;
        // }
        this.setState({ ship_date: e });
      }

    handleOnSave = (e) => {
        e.preventDefault();
        this.state.rows.map((r) => {
            // r.recreate = false;
        });
        // this.props.updateFJAgents(this.props.fjCustomerId, this.state.rows).then((response) => {
        //     // alert(JSON.stringify(response.data));
        //     alert("Agents Saved");
        //     this.props.closeAgentModal();
        //   }, (err) => {
        //     if (err.status === 500 || err.status === 404) {
        //       alert(JSON.stringify(err.data));
        //     }
        //   });
        // this.props.onSave(this.state.rows);
    }

    handlePrintPdf = (e) => {
        e.preventDefault();
        this.props.printSalesOrderLabelBOL(this.state.selectedRows[0].id);
        // this.props.testHAHA(376);
    }

    handleEdit = (e) => {
        e.preventDefault();
        axios({
            method: 'PUT',
            data: {ship_date: this.state.ship_date},
            url: `${ROOT_URL}v2/sales/bol/${this.state.selectedRows[0].id}/`,
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        })
            .then(res => {
                axios({
                    method: 'GET',
                    url: `${ROOT_URL}v2/sales/bol/`,
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                })
                    .then(res => {
                        this.setState({
                            rows: res.data,
                            selectedRows: [],
                            editedRows: [],
                        });
                    }, err => {
                    });
                    this.setState({editShipDateVisible: false});
            }, err => {
                // this.setState({editShipDateVisible: false});
            })
    }

    handleDelete = (e) => {
        e.preventDefault();

        axios({
            method: 'DELETE',
            url: `${ROOT_URL}v2/sales/bol/${this.state.selectedRows[0].id}/`,
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        })
            .then(res => {
                
                axios({
                    method: 'GET',
                    url: `${ROOT_URL}v2/sales/bol/`,
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                })
                    .then(res => {
                        this.setState({
                            rows: res.data,
                            selectedRows: [],
                            editedRows: [],
                        });
                    }, err => {
                    })

            }, err => {
                alert("Error, could not delete BOL.");
            })

    }

    // handleExcel = (e) => {
    //     e.preventDefault();
    // }

    renderExcel() {
        let { selectedRows } = this.state;
        let temp = null;
        if (selectedRows && selectedRows.length > 0) {
            temp = selectedRows[0].id;
        }
        const exportUrl = `${ROOT_URL}v2/sales/bol/export/${temp}?mode=xls&Bearer=${localStorage.getItem("token")}`;
        return (
          <Button
            bsStyle="success"
            type="button"
            href={exportUrl}
            disabled={selectedRows.length !== 1}
            >
            <em className="fa fa-download" />
            <Translate value="export_excel" />
          </Button>
        );
    }

    clickNew(e) {
        e.preventDefault();
        let rows = Selectors.getRows(this.state);
        let index = rows.length;
        let newRow = { name: null, note: null, customer: this.props.fjCustomerId, Idx: index };
        rows.push(newRow);
        let editedRows = [...this.state.editedRows];
        editedRows.push(newRow)
        this.setState({ rows, editedRows })
    }

    deleteCategory(e) {
        e.preventDefault();
        let rows = [...this.state.rows];
        let editedRows = [...this.state.editedRows];
        let index = _.findIndex(rows, { Idx: this.state.selectedRows[0].Idx })

        if (this.state.selectedRows[0].id) {
            // this.props.deleteFJAgents(this.state.selectedRows[0].id).then((response) => {
            //     alert("Agent Deleted");
            //     rows.splice(index, 1);
            //     index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx })
            //     editedRows.splice(index, 1);
            //     this.setState({ rows, editedRows, selectedRows: [] })
            //     // this.props.fetchFJAgents(this.props.fjCustomerId).then((response) => {
            //     //     if (response.data) {
            //     //         this.initializeModal(response.data);
            //     //     }
            //     // }, (err) => {
            //     //     if (err.status === 500 || err.status === 404) {
            //     //         alert("Server error, please refresh page. If problem persists, contact administrator.");
            //     //     }
            //     // });
            // }, (err) => {
            //     if (err.status === 500 || err.status === 404 || err.status === 405) {
            //         alert("Error cannot delete agent.");
            //     }
            // });
        }

        // rows.splice(index, 1);
        // index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx })
        // editedRows.splice(index, 1);
        // this.setState({ rows, editedRows, selectedRows: [] })
    }

    renderAgentTable() {
        const getRows = () => {
            return Selectors.getRows(this.state);
        }
        const getSize = () => {
            return getRows().length;
        }
        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }
        const handleRowUpdated = e => {
            this.setState({ sortColumn: null, sortDirection: null })
            let rows = getRows();
            let editedRows = this.state.editedRows.slice(0);
            Object.assign(rows[e.rowIdx], e.updated);
            editedRows.forEach((element, index) => {
                if (element.Idx === rows[e.rowIdx].Idx)
                    editedRows.splice(index, 1)
            }, this);
            editedRows.push(rows[e.rowIdx]);
            this.setState({
                rows: rows,
                editedRows: editedRows,
            });
        }
        // const onRowsSelected = (rows) => {
        //     let newRows = getRows();
        //     newRows.map(r => {
        //         r.isSelected = false;
        //     })
        //     rows.map(r => {
        //         newRows[r.rowIdx].isSelected = true;
        //     });
        //     this.setState({ rows: newRows, selectedRows: [rows[0].row] });
        // }
        const onRowsSelected = (rows) => {
            let newRows = getRows();
            let selectedRows = [...this.state.selectedRows];
            rows.map(r => {
                newRows[r.rowIdx].isSelected = true;
                selectedRows.push(r.row);
            });
            this.setState({ rows: newRows, selectedRows });
        }
        // const onRowsDeselected = (rows) => {
        //     let newRows = getRows();
        //     rows.map(r => {
        //         newRows[r.rowIdx].isSelected = false;
        //     });
        //     this.setState({ rows: newRows, selectedRows: [] });
        // }
        const onRowsDeselected = (rows) => {
            let newRows = [...this.state.rows];
            let selectedRows = [...this.state.selectedRows];
            rows.map((r) => {
                newRows[r.rowIdx].isSelected = false;
                const rowIndex = selectedRows.indexOf(r.row);
                selectedRows.splice(rowIndex, 1);
            });
            this.setState({ rows: newRows, selectedRows });
        }

        const handleGridSort = (sortColumn, sortDirection) => {
            var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
            this.setState(state);
          }

        const handleFilterChange = filter => {
            let newFilters = Object.assign({}, this.state.filters);
            if (filter.filterTerm) {
              newFilters[filter.column.key] = filter;
            } else {
              delete newFilters[filter.column.key];
            }
            this.setState({ filters: newFilters });
          }

        const SecondsDateFormatter = React.createClass({
            render() {
              if (this.props.value) {
                const date = moment(this.props.value).format("MM-DD-YY HH:mm");
                return <span>{date}</span>;
              }
              return <span className="label label-danger">-</span>;
            },
          });

          const DateFormatter2 = React.createClass({
            render() {
              if (this.props.value) {
                const date = moment(this.props.value).format("MM-DD-YY");
                return <span>{date}</span>;
              }
              return <span className="label label-danger">-</span>;
            },
          });

        const columns = [
            // {
            //     key: 'so_num',
            //     name: <Translate value="so_num" />,
            //     resizable: true,
            //     sortable: true,
            //     filterable: true,
            //     width: 120,
            // },
            {
                key: 'trailer_num',
                name: <Translate value="trailer" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 120,
            },
            {
                key: 'load_num',
                name: <Translate value="load" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 120,
            },
            {
                key: 'isa_num',
                name: <Translate value="isa" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 100,
            },
            {
                key: 'pro_num',
                name: <Translate value="pro" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 100,
            },
            {
                key: 'seal_num',
                name: <Translate value="seal" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 100,
            },
            {
                key: 'ship_date',
                name: <Translate value="ship_date" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 100,
                formatter: DateFormatter2,
            },
            {
                key: 'ship_name',
                name: <Translate value="name" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 100,
            },
            {
                key: 'ship_street',
                name: <Translate value="street" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 100,
            },
            {
                key: 'ship_city',
                name: <Translate value="city" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 100,
            },
            {
                key: 'ship_state',
                name: <Translate value="state" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 100,
            },
            {
                key: 'ship_zip',
                name: <Translate value="zip" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 100,
            },
            {
                key: 'create_datetime',
                name: <Translate value="created" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 110,
                formatter: SecondsDateFormatter,
            },
            {
                key: "is_3party",
                name: <Translate value="3rd_party" />,
                resizable: true,
                sortable: true,
                // filterable: true,
                width: 100,
                formatter: ({ value }) => (
                    <div>
                        { (value === true || value === 'true') ? "true" : "false"}
                    </div>
                ),
            },
            {
                key: "is_collect",
                name: <Translate value="collect" />,
                resizable: true,
                sortable: true,
                // filterable: true,
                width: 100,
                formatter: ({ value }) => (
                  <div>
                    { (value === true || value === 'true') ? "true" : "false" }
                  </div>
                ),
              },
              {
                key: "is_prepaid",
                name: <Translate value="prepaid" />,
                resizable: true,
                sortable: true,
                // filterable: true,
                width: 100,
                formatter: ({ value }) => (
                  <div>
                    { (value === true || value === 'true') ? "true" : "false" }
                  </div>
                ),
              },
        ]

        const onRowClick = (rowIdx, row) => {
            if (rowIdx !== -1) {
              const rows = getRows();
              rows.map((r) => {
                r.isSelected = false;
              });
              const selectedRows = [rows[rowIdx]];
              rows[rowIdx].isSelected = true;
            this.setState({ rows, selectedRows });

            //   const salesOrders = { ...this.state.salesOrders, rows, selectedRows };
            //   this.setState({ salesOrders });
            //   this.props.fetchSalesOrderDetail(row.SalesOrder_id, route);
            let temp = {
                rows: [],
                selectedRows: null,
                editedRows: [],
                filters: {},
            };
              if (selectedRows && selectedRows[0]) {
                temp.rows = selectedRows[0].lines;
                this.setState({ details: temp });
              }
            }
          };

        return (
            <Row>
                <Col>
                    {/* <div style={{ maxWidth: '550px', marginLeft: '25px' }}> */}
                    {/* <div style={{marginTop: "100px"}}> */}
                    <div>
                        <ReactDataGrid
                            // rowKey="Idx"
                            enableCellSelect={true}
                            onGridSort={handleGridSort}
                            onAddFilter={handleFilterChange}
                            columns={columns}
                            rowGetter={rowGetter}
                            rowsCount={getSize()}
                            minHeight={295}
                            rowHeight={25}
                            headerRowHeight={45}
                            toolbar={<Toolbar enableFilter />}
                            enableRowSelect='single'
                            onRowUpdated={handleRowUpdated}
                            rowSelection={{
                                showCheckbox: true,
                                onRowsSelected,
                                onRowsDeselected,
                                selectBy: {
                                    isSelectedKey: 'isSelected'
                                }
                            }}
                            onRowClick={onRowClick}
                        />
                    </div>
                </Col>
            </Row>
        )
    }

////////////
////////////////////////////////////////////////////////////////////////
////////////
    renderDetailTable() {
        const getRows = () => {
            return Selectors.getRows(this.state.details);
        }
        const getSize = () => {
            return getRows().length;
        }
        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }

        const columns = [
            {
                key: 'sku',
                name: 'SKU',
                resizable: true,
                sortable: true,
                filterable: true,
                width: 150,
            },
            {
                key: 'fba',
                name: 'FBA',
                resizable: true,
                sortable: true,
                filterable: true,
                width: 120,
            },
            // {
            //     key: 'prod_name',
            //     name: <Translate value="product_name" />,
            //     resizable: true,
            //     sortable: true,
            //     filterable: true,
            //     width: 200,
            // },
            {
                key: 'quantity',
                name: <Translate value="quantity" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 100,
            },
            {
                key: 'note',
                name: <Translate value="note" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 250,
            },
        ]

        return (
            <Row>
                <Col>
                    {/* <div style={{ maxWidth: '550px', marginLeft: '25px' }}> */}
                    <div>
                        <ReactDataGrid
                            // rowKey="Idx"
                            enableCellSelect={true}
                            columns={columns}
                            rowGetter={rowGetter}
                            rowsCount={getSize()}
                            minHeight={140}
                            rowHeight={25}
                            headerRowHeight={45}
                            // enableRowSelect='single'
                            // rowSelection={{
                            //     showCheckbox: true,
                            //     onRowsSelected,
                            //     onRowsDeselected,
                            //     selectBy: {
                            //         isSelectedKey: 'isSelected'
                            //     }
                            // }}
                        />
                    </div>
                </Col>
            </Row>
        )
    }

    render() {
        const {
        } = this.props;

        const {
        } = this.state;

        const dialogStyleWiz = {
            width: "550px",
            height: "200px",
            marginLeft: "-10%",
          };

        return (
            <div>
                {/* <ButtonToolbar style={{ marginLeft: '5px', marginBottom: '7px' }}>
                    <Button
                        bsStyle="primary"
                        onClick={(event) => { this.clickNew(event) }}
                    >
                        <em className="fa fa-plus marginRightStyle" /><Translate value="add" />
                    </Button>
                    <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="danger"
                        onClick={(event) => { this.deleteCategory(event) }}
                        disabled={!this.state.selectedRows || this.state.selectedRows.length != 1}
                    ><em className="fa fa-trash marginRightStyle" /><Translate value="delete" />
                    </Button>
                </ButtonToolbar> */}
                <Row>
                    <Col className="text-center">
                        <div style={{padding: '0px 25px'}}>
                            {this.renderAgentTable()}
                        </div>
                    </Col>
                </Row>

                <Row>
                <p style={{padding: '0px 25px', fontWeight: 'bold', fontSize: '18px', marginTop: '5px', marginBottom: '0px' }}>
                  <Translate value="details" />
                </p>
                    <Col className="text-center">
                        <div style={{padding: '0px 25px'}}>
                            {this.renderDetailTable()}
                        </div>
                    </Col>
                </Row>

                <Row className="centerStyle" style={{ marginTop: '15px' }}>
                    <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="warning"
                        onClick={(e) => { this.setState({editShipDateVisible: true}); }}
                        disabled={this.state.selectedRows.length !== 1}
                    >
                        <Translate value="ship_date" />
                    </Button>
                    <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="success"
                        onClick={(e) => { this.handlePrintPdf(e); }}
                        disabled={this.state.selectedRows.length !== 1}
                    >
                        <em className="fa fa-print" />
                        <Translate value="print_pdf" />
                    </Button>
                    {this.renderExcel()}
                    <Button
                        style={{ marginLeft: '5px' }}
                        bsStyle="danger"
                        onClick={(e) => { this.handleDelete(e); }}
                        disabled={this.state.selectedRows.length !== 1}
                    >
                        <Translate value="delete" />
                    </Button>
                    {/* <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="success"
                        onClick={(e) => { this.handleExcel(e); }}
                        disabled={this.state.selectedRows && this.state.selectedRows.length !== 1}
                    >
                        <em className="fa fa-download" />
                        <Translate value="export_excel" />
                    </Button> */}

                    {/* <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="success"
                        onClick={(e) => { this.handleOnSavePrint(e); }}
                    >
                        <Translate value="save_and_print" />
                    </Button> */}
                    {/* <Button
                        bsStyle="success"
                        onClick={(e) => { this.handleOnRecreate(e); }}
                        disabled={!this.state.selectedRows || this.state.selectedRows.length < 1}
                    >
                        <Translate value="recreate" />
                    </Button> */}
                </Row>

                <SkyLightStateless
        dialogStyles={dialogStyleWiz}
        isVisible={this.state.editShipDateVisible}
        onCloseClicked={() => {
          this.setState({editShipDateVisible: false});
          // this.closeDSQPrint();
        }}
        title={"Ship Date"}
      >
        <div>
        <Row>
                              <Col xs={6}>
        <label style={{marginRight: '5px'}}><Translate value="ship_date" />:</label>
        {
            GenericDatePicker({
            setDate: this.setShipDate,
            selectedDate: this.state.ship_date,
            onChange: (e) => {
            this.setShipDate(e);
            },
        })
        }
            </Col>
        </Row>
        <Row className="centerStyle" style={{ marginTop: '15px' }}>
                    <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="success"
                        onClick={(e) => { this.handleEdit(e); }}
                        disabled={false}
                    >
                        <Translate value="save" />
                    </Button>
</Row>
        </div>
      </SkyLightStateless>
            </div>
        );
    }
}

export default BOLListModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/bolListModal.jsx